import React from 'react'
import { Avatar, Box, Button, Divider, Typography } from '@mui/material'
import { CallOutlined, Facebook } from "@mui/icons-material"
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { CustomStyles } from '../../../../../../../../core/global/realproperty/styles/CustomStyles';
import { BestIcon, FeatIcon } from '../../../../../../../../core/global/Icons';
import { ToolTip } from '../../../../../../../../core/global/realproperty/styles/Tooltip';



export const Info = ({ handleOpenText, leftBar, opentxtfld, open_i, fileHandler, t_form, error }) => {
    const dsginfo = t_form.data.styles
    const d = t_form.data.styles.names.images
    const classes = CustomStyles()

    return (
        <Box width="100%" height="100%">
            <ToolTip title="Click to edit." arrow>
                <Typography px={3} width="100%" border={opentxtfld === "title" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('title')}
                    fontSize={72} fontWeight={600} color="#313131" className={classes.hover} >
                    {dsginfo.names.title.value}
                </Typography>
            </ToolTip>
            <ToolTip title="Click to edit" arrow>
                <Box px={3} mt={2} className={classes.hover} border={opentxtfld === "title_description" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('title_description')}
                    fontSize={16} fontWeight={400} color="#6A6A6A"
                >
                    {dsginfo.names.title_description.value}
                </Box>
            </ToolTip>
            <Box width="100%" mt={2} display="flex" alignItems="center">
                <ToolTip title="Click to edit" arrow>
                    <Box px={3} className={classes.hover} border={opentxtfld === "start_price" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('start_price')}
                        fontSize={32} fontWeight={700} color="#313131"
                    >
                        {dsginfo.names.start_price.value}
                    </Box>
                </ToolTip>
                <ToolTip title="Click to edit" arrow>
                    <Box px={3} className={classes.hover} border={opentxtfld === "price" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('price')}
                        fontSize={32} fontWeight={700} color="#ED9140"
                    >
                        ₱ {dsginfo.names.price.value}
                    </Box>
                </ToolTip>
            </Box>

            <Box display="flex" alignItems="center" gap={2} mt={2} pl={2}>
                <ToolTip title="Click to edit" arrow>
                    <Box sx={{ ':hover': { border: "#009F4D solid 2px", p: 1 } }} border={opentxtfld === 'second_button' && leftBar === true && "#009F4D solid 2px"} p={opentxtfld === 'second_button' && leftBar === true && 1} onClick={() => handleOpenText('second_button')}>
                        <Button sx={{
                            fontSize: 14, fontWeight: 500, color: "#FFFFFF", bgcolor: "#ED9140",
                            border: `solid 2px`, height: '52px', width: '180px', ':hover': { color: "#363535" }
                        }}
                        >{dsginfo.names.buttons.second.label}</Button>
                    </Box>
                </ToolTip>
            </Box>

            <Box px={3} display="flex" alignItems="center" my={6} gap={2}>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
                <Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3" gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
            </Box>
            <Box mx={3} borderRadius={3} onClick={() => handleOpenText('inclu_bestfor')} className={classes.hover} border={opentxtfld === "inclu_bestfor" && leftBar === true && "#009F4D solid 2px"}>
                <ToolTip title="Click to edit" arrow>
                    <Box pb={2} width="100%" /*bgcolor="#e3e3e3"*/ bgcolor="#FBF8F7"
                        pt={5} borderRadius={3} border={open_i.data === "bg_bestfor" && leftBar === true && "#009F4D solid 1px"}>
                        <Box px={5} display="flex" alignItems="center" border={open_i.data === "bft" && leftBar === true && "#009F4D solid 2px"}>
                            <BestIcon />
                            <Box pl={1} fontSize={24} fontWeight={600} color="#313131">{dsginfo.names.bestfor_title.value} :</Box>
                        </Box>
                        <Box width="100%" display="flex" alignItems="center" flexWrap="wrap" fontSize={16} fontWeight={400} p="8px 24px 8px 48px" border={open_i.data === "bfi" && leftBar === true && "#009F4D solid 2px"}>
                            {dsginfo.names.bestfor_items.map((i, k) => (
                                <Box key={k} width="50%" fontSize={16} fontWeight={400} color="#313131">•  {i.value} </Box>
                            ))}

                        </Box>
                    </Box>
                </ToolTip>
            </Box>

            <Box mx={3} borderRadius={3} onClick={() => handleOpenText('inclu_features')} mt={3} className={classes.hover} border={opentxtfld === "inclu_features" && leftBar === true && "#009F4D solid 2px"}>
                <ToolTip title="Click to edit" arrow>
                    <Box pb={2} width="100%" /*bgcolor="#e3e3e3"*/ bgcolor="#FBF8F7"
                        pt={5} borderRadius={3} border={open_i.data === "bg_features" && leftBar === true && "#009F4D solid 1px"}>
                        <Box px={5} display="flex" alignItems="center" border={open_i.data === 'ft' && leftBar === true && "#009F4D solid 2px"}>
                            <FeatIcon />
                            <Box pl={1} fontSize={24} fontWeight={600} color="#313131"> {dsginfo.names.feature_title.value} : </Box>
                        </Box>
                        <Box width="100%" display="flex" alignItems="center" flexWrap="wrap" fontSize={16} fontWeight={400} p="8px 24px 8px 48px" border={open_i.data === 'fi' && leftBar === true && "#009F4D solid 1px"}>
                            {dsginfo.names.feature_items.map((i, k) => (
                                <Box fontSize={16} fontWeight={400} color="#313131" key={k} width="50%">•  {i.value}</Box>
                            ))}
                        </Box>
                    </Box>
                </ToolTip>
            </Box>
            <Box px={3} display="flex" alignItems="center" my={6} gap={2}>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
                <Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3" gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
            </Box>
            <Box>
                <ToolTip title="Click to edit" arrow>
                    <Typography px={3} border={opentxtfld === "atp_title" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('atp_title')}
                        fontSize={24} fontWeight={600} color="#313131" className={classes.hover} >
                        {dsginfo.names.atp_title.value}
                    </Typography>
                </ToolTip>
                <ToolTip title="Click to edit" arrow>
                    <Typography border={opentxtfld === "atp_description" && leftBar === true && "#009F4D solid 2px"} pt={1} px={3} my={.5} onClick={() => handleOpenText('atp_description')}
                        fontSize={16} fontWeight={400} color="#6A6A6A" className={classes.hover}
                    >
                        {dsginfo.names.atp_description.value}
                    </Typography>
                </ToolTip>
                {/* <Button sx={{ fontSize: 16, fontWeight: 600, color: "#313131", ml: 2 }}>Read more...</Button> */}
            </Box>
            <Box px={3} display="flex" alignItems="center" my={6} gap={2}>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
                <Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3" gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
            </Box>
            <Box>

                <Box display="flex" position={"relative"}>
                    {error.data.proceed && d.owner_img.type === 'default' && <Box textAlign={"center"} width={300} border="solid 2px" color="red" position={"absolute"} fontSize={14} mt={-6} zIndex={1}>This image is for default only. Please insert your own image!</Box>}
                    <Box pl={2} component="label" >
                        <ToolTip title="Input image" arrow>
                            <Avatar className="c-pointer" sx={{ width: 72, height: 72, border: error.data.proceed && d.first_img.type === 'default' && "red solid 2px" }} src={dsginfo.names.images.owner_img.object} />
                        </ToolTip>
                        <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('owner_img', e)} />
                    </Box>
                    <Box>
                        <ToolTip title="Click to edit" arrow>
                            <Box px={1} width="100%" border={opentxtfld === "owner_name" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('owner_name')}
                                fontSize={20} fontWeight={600} color="#313131" className={classes.hover}
                            >
                                {dsginfo.names.owner_name.value}
                            </Box>
                        </ToolTip>
                        <ToolTip title="Click to edit" arrow>
                            <Box px={1} width="100%" border={opentxtfld === "owner_title" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('owner_title')}
                                fontSize={16} fontWeight={400} color="#ED9140" className={classes.hover}
                            >
                                {dsginfo.names.owner_title.value}
                            </Box>
                        </ToolTip>
                    </Box>
                </Box>
                <Box pl={9}>
                    <ToolTip title="Click to edit" arrow>
                        <Box border={opentxtfld === "owner_description" && leftBar === true && "#009F4D solid 2px"} onClick={(e) => handleOpenText('owner_description')}>
                            <Typography width="100%" mb={2} px={3}
                                fontSize={16} fontWeight={400} color="#313131" className={classes.hover}
                            >
                                {dsginfo.names.owner_description.value}
                            </Typography>
                        </Box>
                    </ToolTip>
                </Box>

            </Box>
            <Box px={3} display="flex" alignItems="center" my={6} gap={2}>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
                <Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3" gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
                <Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
            </Box>
            <Box >
                <ToolTip title="Click to edit" arrow>
                    <Box pl={3} border={opentxtfld === "contact_title" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('contact_title')}
                        fontSize={24} fontWeight={600} color="#313131" className={classes.hover}
                    >
                        {dsginfo.names.contact_title.value}
                    </Box>
                </ToolTip>
                <Box display="flex" gap={2} mt={1}>
                    <ToolTip title="Click to edit" arrow>
                        <Box px={3} display="flex" alignItems="center" border={opentxtfld === "cellphone_num" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('cellphone_num')}
                            fontSize={16} fontWeight={400} color="#313131" className={classes.hover}
                        >
                            <PhoneIphoneIcon sx={{ color: '#999797', fontSize: 24 }} />
                            {dsginfo.names.cellphone_num.value}
                        </Box>
                    </ToolTip>
                    <ToolTip title="Click to edit" arrow>
                        <Box px={3} display="flex" alignItems="center" border={opentxtfld === "telephone_num" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('telephone_num')}
                            fontSize={16} fontWeight={400} color="#313131" className={classes.hover}
                        >
                            <CallOutlined sx={{ color: '#999797', fontSize: 24, mr: 2 }} />
                            {dsginfo.names.telephone_num.value}
                        </Box>
                    </ToolTip>
                </Box>
            </Box>

            <Box mt={6}>
                <ToolTip title="Click to edit" arrow>
                    <Box pl={3} width="100%"
                        fontSize={24} fontWeight={600} color="#313131"
                    >
                        {dsginfo.names.social_title.value}
                    </Box>
                </ToolTip>
            </Box>

            <Box pb={5}>
                <ToolTip title="Click to edit" arrow>
                    <Box className={classes.hover} width={200} border={opentxtfld === "social_icon" && leftBar === true && "#009F4D solid 2px"} onClick={() => handleOpenText('social_icon')}>
                        <Box display="flex" alignItems="center" pl={3}>
                            <Facebook sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64 }} />
                            <InstagramIcon sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64, mx: 3 }} />
                            <TwitterIcon sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64 }} />
                        </Box>
                    </Box>
                </ToolTip>
            </Box>


        </Box>
    )
}
